export default "__VITE_ASSET__Dl6vri_i__"